<template>
  <label-component :kind="kind" :text="text" :class="classes" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useDynamicMountChild } from "@plugins/common/composables/dynamic-mount-child.ts";
import LabelComponent from "@plugins/common/components/LabelComponent.vue";

const props = withDefaults(
  defineProps<{
    kind?: string;
    textLabelKey?: string;
    classes?: string;
    // eslint-disable-next-line vue/prop-name-casing
    dynamicMountChildMixin_parentComponent?: object;
    // eslint-disable-next-line vue/prop-name-casing
    dynamicMountChildMixin_isDynamicallyMounted?: boolean;
  }>(),
  {
    kind: "",
    textLabelKey: "",
    classes: "",
    dynamicMountChildMixin_parentComponent: () => ({}),
    dynamicMountChildMixin_isDynamicallyMounted: false,
  },
);

useDynamicMountChild({
  dynamicMountChildMixin_parentComponent: props.dynamicMountChildMixin_parentComponent,
  dynamicMountChildMixin_isDynamicallyMounted: props.dynamicMountChildMixin_isDynamicallyMounted,
});

const { t } = useI18n();

const kind = computed(() => props.kind);
const classes = computed(() => props.classes);
const text = computed(() => t(props.textLabelKey));
</script>
